export enum ModuleCode {
  SERVICE_PROVIDER = '3RD_PARTY_SERVICE_PROVIDER',
  PURCHASE_AO = 'PURCHASE_AO',
  CUSTOMER_PORTAL = 'CUSTOMER_PORTAL',
  TABLET_PORTAL = 'TABLET_PORTAL',
  SETTINGS_STATUSES = 'SETTINGS_STATUSES',
}
